import React from 'react';
import { cva } from 'class-variance-authority';
import { cn } from '../../lib/utils';

/**
 * NEXORA Ocean Design System (NODS)
 * Badge Component
 * 
 * Status indicators with semantic colors
 */

const badgeVariants = cva(
  'inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-xs font-medium transition-colors duration-200',
  {
    variants: {
      variant: {
        default: 'bg-primary/10 text-primary border border-primary/20',
        success: 'bg-success/10 text-success border border-success/20',
        warning: 'bg-warning/10 text-warning border border-warning/20',
        error: 'bg-error/10 text-error border border-error/20',
        secondary: 'bg-secondary text-secondary-foreground border border-border',
        outline: 'border border-border text-text-primary'
      }
    },
    defaultVariants: {
      variant: 'default'
    }
  }
);

export const Badge = React.forwardRef((
  { className, variant, children, ...props },
  ref
) => {
  return (
    <span
      ref={ref}
      className={cn(badgeVariants({ variant }), className)}
      {...props}
    >
      {children}
    </span>
  );
});

Badge.displayName = 'Badge';

export default Badge;
